<template>
    <div class="plano_modal" v-if="visible">
        <b-card>
            <label> <h3>Edit Separator</h3> </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="3"> <label>Fixed:</label> </b-col>
                    <b-col sm="9"> <b-form-checkbox v-model="fixed"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3"> <label>Height:</label> </b-col>
                    <b-col sm="9"> <NumberInput v-model="height"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3"> <label>X:</label> </b-col>
                    <b-col sm="9"> <NumberInput v-model="x"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3"> <label>Y:</label> </b-col>
                    <b-col sm="9"> <NumberInput v-model="y"></NumberInput> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">Ok</b-button>
                <b-button style="margin:5px;" @click="cancel();">Cancel</b-button>
            </b-button-toolbar>
        </b-card>
    </div>
</template>

<script>
import NumberInput from "../components/number-input";

let editBoardSeparatorWidget;
window.editBoardSeparator = function editBoardSeparator(data, onValidate, onCancel) {
    editBoardSeparatorWidget.fixed = data.fixed;
    editBoardSeparatorWidget.height = data.height;
    editBoardSeparatorWidget.x = data.x;
    editBoardSeparatorWidget.y = data.y;
    editBoardSeparatorWidget.visible = true;
    editBoardSeparatorWidget.onValidate = onValidate;
    editBoardSeparatorWidget.onCancel = onCancel;
};

export default {
    components: { NumberInput },
    data() {
        return {
            height: 0,
            x: 0,
            y: 0,
            fixed: false,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    created() {
        editBoardSeparatorWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({
                height: parseFloat(this.height),
                x: parseFloat(this.x),
                y: parseFloat(this.y),
                fixed: this.fixed
            });
            this.visible = false;
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// edit_board_separator.vue?7af1a872